/*
 * @Descripttion:
 * @version:
 * @Author: dtao
 * @Date: 2022-08-04 14:00:14
 * @LastEditors: rqcheng
 * @LastEditTime: 2025-06-20 14:52:55
 */
export * from "./network";
// 路由白名单
export const routesWhiteList = ["/login"];

export const tencentMapKey = "FDOBZ-BUKYD-UZK4Q-HCPLB-45L6K-75BRJ";

export const WIND_DRIECTIONS = {
  E: "东",
  ESE: "东东南",
  SE: "东南",
  SSE: "南东南",
  S: "南",
  SSW: "南西南",
  SW: "西南",
  WSW: "西西南",
  W: "西",
  WNW: "西西北",
  NW: "西北",
  NNW: "北西北",
  N: "北",
  NNE: "北东北",
  NE: "东北",
  ENE: "东东北"
};
// 氣象要素
export const METEO_FACTOR_LIST = [
  {
    id: 1,
    label: "温度",
    unit: "℃",
    key: "tem",
    vk: ["tem_min_24h", "tem_max_24h"],
    img_url: "",
    color: ["#409EFF", "#ff0000", "#ff7916"],
    position: ["bottom", "top"]
  },
  {
    id: 2,
    label: "气压",
    unit: "hPa",
    key: "prs",
    vk: ["prs"],
    img_url: require("../assets/home/atom.png"),
    color: ["#0ecbb2"],
    position: ["top"]
  },
  {
    id: 3,
    label: "相对湿度",
    unit: "%",
    key: "rhu",
    vk: ["rhu"],
    img_url: require("../assets/home/hor.png"),
    color: ["#008aff"],
    position: ["top"]
  },
  {
    id: 4,
    label: "可降水分",
    unit: "mm",
    key: "pre",
    vk: ["pre_pre_fore"],
    img_url: require("../assets/home/pre.png"),
    color: ["#2fcbe2"],
    position: ["top"]
  },
  {
    id: 5,
    label: "风力风向",
    unit: "m/s",
    key: "win_s_max",
    vk: ["win_s"],
    img_url: require("../assets/home/wind.png"),
    color: ["#5c72f7"],
    position: ["top"]
  }
];
export const SMS_CONFIG = {
  "0": "register",
  "1": "reset_phone",
  "2": "reset_pwd"
};



// WEBPACK FOOTER //
// ./src/config/index.js